import { BellAlertIcon, BellIcon } from '@heroicons/react/24/outline'
import { cloneDeep } from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { notificationsFetch } from './NotificationsActions'

class Notifications extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loaded: false,
      unseen: {
        lastPage: 0,
        page: 0,
      },
    }
    this.refreshTimeout = null
  }

  static getDerivedStateFromProps(props, state) {
    const {
      notifications: { unseen },
      user,
    } = props
    const newState = cloneDeep(state)

    if (user) {
      if (unseen.loaded && !unseen.pagination) {
        newState.unseen = {
          lastPage: 0,
          page: 0,
        }
      } else {
        const page =
          unseen.pagination && unseen.pagination.current_page ? unseen.pagination.current_page : state.unseen.page

        newState.unseen = {
          lastPage:
            unseen.pagination && unseen.pagination.last_page !== undefined ? unseen.pagination.last_page : page + 1,
          page,
        }
      }

      return newState
    }
    return null
  }

  componentDidMount() {
    clearTimeout(this.refreshTimeout)
    this.refreshTimeout = setTimeout(this.onRefreshNotifications, 7000)
  }

  componentWillUnmount() {
    clearTimeout(this.refreshTimeout)
  }

  onRefreshNotifications = (user = this.props.user) => {
    clearTimeout(this.refreshTimeout)
    if (user) {
      const newState = cloneDeep(this.state)

      this.props.notificationsFetch({ perPage: 1, type: 'unseen' })
      newState.unseen = {
        lastPage: 0,
        page: 0,
      }

      newState.loaded = true
      this.setState(newState)
    }
  }

  render() {
    const {
      notifications: { unseen },
      user,
    } = this.props

    if (!user) {
      return null
    }

    return (
      <Link className="Notifications flex relative items-center h-full" to="/notifications">
        {unseen.pagination?.total > 0 ? <BellAlertIcon className="size-8" /> : <BellIcon className="size-8" />}
        {unseen.loaded && !!unseen.pagination.total && (
          <div className="text-xs absolute bg-redLightest rounded-full -top-1 right-3 translate-x-1/2">
            <span className="text-xs leading-4 font-bold flex items-center justify-center size-9 overflow-hidden">
              {unseen.pagination.total > 99 ? '99+' : unseen.pagination.total}
            </span>
          </div>
        )}
      </Link>
    )
  }
}

Notifications.propTypes = {
  notifications: PropTypes.object.isRequired,
  notificationsFetch: PropTypes.func.isRequired,
  user: PropTypes.object,
}

export default connect(
  ({ auth: { usr }, userNotifications }) => ({
    notifications: userNotifications,
    user: usr,
  }),
  {
    notificationsFetch,
  },
)(Notifications)
